export const SELECTED_NOTIFICATION = "SELECTED_NOTIFICATION";